<template>
  <div
    id="app"
    class="clavo-app"
  >
    <div class="info-bars">
      <info-bar
        v-for="(input, index) in infoBarInputs"
        :key="input.id"
        :message="input.msg"
        :error="input.error"
        :timeout="input.timeout"
        class="bar"
        :style="{
          top: 10 * index+'px'
        }"
        @close="removeInfoBarInput(input)"
      />
    </div>
    <div v-show="isOffline" class="offline-status">
      <img src="@/assets/_desktop/_shared/offline.svg" />
      <span class="offline-bold">{{ $t('youAreOffline') }}</span>
      <span class="try-now" @click="refreshConnection">{{ $t('clickToRefresh') }}</span>
    </div>
    <div v-show="isServerUnavailable" class="offline-status">
      <img src="@/assets/_desktop/_shared/offline.svg" />
      <span class="offline-bold">{{ $t('serverCantBeReached') }}</span>
      <span class="try-now" @click="refreshConnection">{{ $t('clickToRefresh') }}</span>
    </div>    
    <transition name="preloading">
      <preloader
        v-if="!isEverythingLoaded"
        class="preloader-screen"
        :size="36"
        :black-and-white="loaderDelay"
      />
    </transition>
    <transition name="fade">
      <loading-bar v-if="$store.state.showProgressBar" />
    </transition>
    <router-view />
  </div>
</template>

<script>
import InfoBar from '@/components/UI/InfoBar'
import Preloader from '@/components/UI/Preloader'
import LoadingBar from '@/components/UI/LoadingBar'
import EventBus from '@/EventBus'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  components: {
    InfoBar,
    Preloader,
    LoadingBar,
  },
  mixins: [ParseFunctions],
  data() {
    return {
      infoBarInputs: [],
      lastId: 0,
      broadcastChannel: undefined,
      isOffline: false,
      isServerUnavailable: false,
      isEverythingLoaded: false,
      loaderDelay: true,
      lastQuery: undefined
    }
  },
  watch: {
    '$route': async function(to, from) {
      this.$store.commit('setShowProgressBar', false)
    }
  },
  created() {
    window.addEventListener('load', () => this.isEverythingLoaded = true)
    this.broadcastChannel = new BroadcastChannel('login-broadcast') // connect to a broadcast channel named 'login-broadcast'
    this.broadcastChannel.onmessage = function (ev) { if (ev.data == true) window.location.reload() }  // reload after receiving a message
    EventBus.$on('broadcast-login', input => this.broadcastPostMessage(input))  // send a message to any other tabs after user logged in

    if(performance.navigation.type == performance.navigation.TYPE_RELOAD){
      this.$store.commit('setStripeScriptLoaded', false)
    }

    setTimeout(() => {
      this.loaderDelay = false;
    }, 2000)

    EventBus.$on('new-info-bar-msg', input => {

      input.id = this.lastId++
      this.infoBarInputs.push(input)
    })
    EventBus.$on('clear-info-bars', this.clearInfoBarInputs)
    EventBus.$on('serverNotAvailable', query => this.connectionProblem('serverNotAvailable', query))
    EventBus.$on('serverAvailable', () => this.connectionProblemEnd('serverNotAvailable'))
    window.addEventListener('offline', (query) => this.connectionProblem('offline', query))
    window.addEventListener('online', () => this.connectionProblemEnd('offline'))

    let lang = navigator.language
    if (lang !== 'en-US' && lang !=='en_US'){
      this.$i18n.locale = 'en_GB'
    }

  },
  beforeDestroy() {
    this.broadcastChannel.close() // disconnect the channel
    EventBus.$off('broadcast-login', this.broadcastPostMessage())
    EventBus.$off('new-info-bar-msg')
    EventBus.$off('clear-info-bars')
    EventBus.$off('serverNotAvailable')
    EventBus.$off('serverAvailable')
    window.removeEventListener('online')
    window.removeEventListener('offline')
    window.removeEventListener('load')
  },
  methods: {
    connectionProblem(type, query){
      if (type === 'offline'){
        this.isOffline = true
      }if (type === 'serverNotAvailable'){
        this.isServerUnavailable = true
      }
      this.lastQuery = query
    },
    async connectionProblemEnd(type){
      if (this.isServerUnavailable || this.isOffline){
        this.isOffline = false
        this.isServerUnavailable = false
        EventBus.$emit('api-fixed', {type})
      }
      // let query = this.lastQuery
      // if (query){
        
      //   let res = await this.run(query.functionName, query.argsObj, query.callbackName)
      //   this.lastQuery = undefined
      // }
    },
    removeInfoBarInput(arg) {
      this.infoBarInputs = this.infoBarInputs.filter(v => v.id !== arg.id)
    },
    clearInfoBarInputs() {
      this.infoBarInputs = []
    },
    broadcastPostMessage(input) {
      if (input) this.broadcastChannel.postMessage(input)
    },
    refreshConnection() {
      // this.connectionProblemEnd('refresh')
      EventBus.$emit('reload-teams')
      //window.location.reload()
    },
  },
}
</script>

<style lang="scss">
@import '~@/scss/fonts/averta/style.scss';
@import '~@/scss/fonts/gochihand/style.scss';
@import '~@/scss/_general.scss';

#app {
  // width: 100%;
  // height: 100%;
  height: 100vh;
  width: 100vw;
  overflow: auto;
}

.info-bars {
  position: fixed;
  z-index: 2001;
  left: 50%;
  top: 20px;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .bar {
    @include fade-in-opacity;
  }
  width: 40%;
  @include respond-below(md) {
    width: 100%;
  }
}
.offline-status {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 0 30px;
  z-index: 2002;
  background-color: #ffda6f;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  font-size: 14px;
  @include fade-in-opacity;
  
  img {
    margin-right: 6px;
  }
  .offline-bold {
    margin: 0 3px;
    @include font-rule('averta-bold');
  }
  .try-now {
    margin-left: 3px;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.2s ease-in-out;
    &:hover {
      color: $blue;
    }
  }
}

.preloading-enter-active, .preloading-leave-active {
  transition: opacity 0.20s;
}
.preloading-enter, .preloading-leave-to {
  opacity: 0;
}

.preloader-screen {
  position: fixed;
  z-index: 2000;
}
// .calendar-outer-wrapper {
//     display: flex;

//     .calendar-inner-wrapper {
//         padding-top: 13px;
//         flex: 1;
//         width: 770px;
//     }

//     .right-panel {
//         flex: 0 0 300px;
//         .now {
//             margin-top: 13px + 35px + 20px;
//         }
//     }
// }

// .calendar-header {
//     display: flex;
//     padding-bottom: 20px;

//     .date-pick {
//         flex: 0 1 200px;
//         display: flex;
//         align-items: center;
//     }

//     .search-user {
//         flex: 0 1 350px;
//     }

//     .spacer {
//         flex: 1 0 15px;
//     }

//     .calendar-switch {
//         flex: 0 0 100px;
//     }
// }

.clavo-link {
  cursor: pointer;

  &.primary {
    color: $blue;

    &:hover {
      color: $dark-blue;
    }
    &:focus-visible {
      outline: 2px solid rgba($blue, 0.3);
    }
  }

  &.danger {
    color: $red;

    &:hover {
      opacity: 0.6;
    }
  }

  &.secondary {
    color: $amethyst;

    &:hover {
      color: $blue;
    }
  }
}

button.clavo-segmented-ctrl {
  background-color: $white-lilac;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.2px;
  font-family: $semibold;
  border: none;
  padding: 8px 20px;
  margin: 0;
  min-height: 36px;
  color: $blue;
  cursor: pointer;
  width: 100%;

  outline: none;

  transition-property: background-color, color;
  transition-duration: 0.1s;
  transition-timing-function: ease-out;

  &.active {
    background-color: $blue;
    color: white;
    cursor: unset;
  }
  &.inactive {
    &:hover {
      background: rgba($blue, 0.75);
      color: white;
    }
    &:focus {
      background: rgba($blue, 0.75);
      color: white;
      outline: none;
    }
  }
  &.forbidden {
    color: $bluebell;
    cursor: not-allowed;
  }
}

button.clavo-button {
  background-color: $blue;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  font-family: $bold;
  border: 1px solid $blue;
  padding: 9px 20px;
  letter-spacing: 0.2px;
  min-height: 40px;
  min-width: 140px;

  position: relative;
  overflow: hidden;

  transition-property: background-color, color;
  transition-duration: 0.1s;
  transition-timing-function: ease-out;

  &.small {
    font-size: 14px;
    min-height: 36px;
    min-width: 100px;
  }

  &.primary {
    background-color: $blue;
    color: white;

    &:hover {
      background-color: white;
      color: $blue;
    }
    &:focus-visible {
      outline: 3px solid rgba($blue, 0.3);
    }

    @include button-ripple-effect($dark-blue, $darkest-blue);
  }

  &.secondary {
    background-color: white;
    color: $blue;

    &:hover {
      background-color: $blue;
      color: white;
    }
    &:focus-visible {
      outline: 3px solid rgba($blue, 0.3);
    }

    @include button-ripple-effect($blue, $dark-blue);
  }

  &.text {
    border-color: white;
    background-color: white;
    color: $blue;
    &:hover {
      background-color: $white-lilac;
      border-color: $white-lilac;  
    }
    &:focus-visible {
      outline: 3px solid rgba($blue, 0.3);
    }

    @include button-ripple-effect($blue, $dark-blue);
  }

  &.clavo-button-danger-primary {
    background-color: $red;
    color: white;
    border-color: $red;

    &:hover {
      background-color: white;
      color: $red;
      border-color: $red;
    }

    @include button-ripple-effect($dark-red, $darkest-red);
  }

  &.clavo-button-danger-secondary {
    background-color: white;
    color: $red;
    border: 1px solid $red;

    &:hover {
      background-color: $red;
      color: white;
    }
    &:focus-visible {
      outline: 3px solid rgba($red, 0.3);
    }

    @include button-ripple-effect($red, #f24f6f);

    &.inactive {
      opacity: 0.75;
      background-color: transparent;
      color: $red;
      border: 1px solid $red;
      cursor: default;
      pointer-events: none;  
    }
  }

  &.clavo-button-inactive,
  &.inactive {
    background-color: transparent;
    color: $bluebell-light;
    border: 1px solid $bluebell-light;
    cursor: default;
    pointer-events: none;
  }

  &.clavo-button-long {
    width: 100%;
  }

  &:focus {
    outline: none;
  }

  &.clavo-button-gray {
    background-color: #b2b6e1;
  }

  &.big,
  &.clavo-button-high {
    height: 50px;
    min-width: 240px;
  }

  &.clavo-button-action {
    background-color: white;
    color: $blue;
    border: 1px solid $blue;
  }

  img {
    position: relative;
    top: 1px;
  }
}

.search-user {
  display: flex;
  padding-left: 4px;
  height: 34px;
  // background-color: $white-lilac;
  border: 1px solid $athens-gray;

  span {
    font-size: 24px;
    top: 5px;
    color: #b2b6e1;
    position: absolute;
  }

  input {
    font-size: 16px;
    line-height: 36px;
    width: 100%;
    background-color: $white-lilac;
    padding-left: 2px;
    margin-top: 0;
  }

  img {
    position: relative;
    top: 1px;
  }
}

img.avatar {
  height: 25px;
  width: 25px;
  object-fit: cover;
  border-radius: 25px;
}

div.notification {
  img {
    @extend .avatar;
    float: left;
  }

  p {
    overflow: auto;
    display: block;
    font-size: 14px;
    padding-left: 15px;
    font-weight: 100;

    span.name {
      font-weight: bold;
    }

    span.time {
      color: $bluebell;
      letter-spacing: -0.2px;
    }
  }

  button {
    font-size: 12px;
    font-family: $bold;
    background-color: white;
    color: $blue;
    border: 1px solid $blue;
    margin-top: 9px;
    padding: 3px 13px;
  }
}

.hoverable-blue:hover {
  color: $blue !important;
}

.hoverable-dark-red:hover {
  color: #c73854 !important;
}

.hoverable-dark-blue:hover {
  color: #2038ce !important;
}

input {
  border-radius: 0;
}

input[type='search'] {
  -webkit-appearance: none;
}

section.popup-section-body {
  margin: 0 84px 36px 84px;
  @include respond-below(sm) {
    margin: 0 0 36px 0;
  }
}
section.modal-confirm-action {
  margin: 0 84px 36px 84px;
  font-size: 16px;
  line-height: 24px;

  p {
    font-family: $regular;
    font-size: 16px;
    line-height: 24px;
    &.warning {
      font-family: $bold;
      margin-top: 24px;
      margin-bottom: 48px;
    }
  }

  .buttons {
    display: flex;
    button {
      flex: 1;
      &:first-child {
        margin-right: 20px;
      }
    }
    @include respond-below(xs) {
      flex-direction: column;
      &:first-child {
        margin-right: 0;
        margin-bottom: 12px;
      }
    }
  }

  @include respond-below(sm) {
    margin: 0 0 36px 0;
  }
}
</style>
